import {z} from 'zod';
import {defineToolRegistryManifest} from '../../types/base-tool-types';

const toolName = 'restore-from-snapshot' as const;

const argumentZod = z.object({
  snapshotId: z
    .string()
    .describe('The ID of the snapshot to restore the site from'),
  keepCommerceCheckout: z
    .boolean()
    .optional()
    .describe(
      'Whether to keep commerce checkout settings during restore. Defaults to true.'
    ),
  keepCommerceInventory: z
    .boolean()
    .optional()
    .describe(
      'Whether to keep commerce inventory during restore. Defaults to false.'
    ),
});

export const restoreFromSnapshotManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Restore from snapshot',
  family: 'site',
  llmTool: {
    name: toolName,
    description:
      'Restores the current site from a snapshot. This enqueues an async restore job and returns immediately. The response includes a taskStatusId to track progress.',
    inputSchema: argumentZod,
  },
  type: 'server',
  permission: [{resource: 'SiteSnapshot', action: 'manage'}],
  confirmBeforeExecuting: true,
});

export type RestoreFromSnapshotArgumentType = z.infer<typeof argumentZod>;
